// extracted by mini-css-extract-plugin
module.exports = {"container":"forgotPasswordPage_container__27xvy"};